import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import Swal from 'sweetalert2';

const CargoModal = ({ isOpen, onClose, refreshTable }) => {
  const [trackingId, setTrackingId] = useState('');
  const [userName, setUserName] = useState('');
  const [fromCountry, setFromCountry] = useState('');
  const [toCountry, setToCountry] = useState('');
  const [date, setDate] = useState('');
  const [lastUpdate, setLastUpdate] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, 'cargo'), {
        tracking_id: trackingId,
        user_name: userName,
        from_country: fromCountry,
        to_country: toCountry,
        date: new Date(date),
        last_update: new Date(lastUpdate),
        status: status,
      });

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Cargo added successfully!',
      });

      refreshTable();
      onClose();
      
    } catch (error) {
      console.error('Error adding document:', error);

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to add cargo. Please try again later.',
      });
    }
  };

  return (
    <div
      className={`${
        isOpen ? 'block' : 'hidden'
      } fixed d-flex align-items-center justify-content-center min-vh-100`}
    >
      <div className="bg-white rounded-lg p-4">
        <h2 className="text-2xl font-bold mb-4">Add New Cargo</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="trackingId">Tracking ID:</label>
            <input
              type="text"
              value={trackingId}
              onChange={(e) => setTrackingId(e.target.value)}
              className="form-control"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="userName">User Name:</label>
            <input
              type="text"
              id="userName"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              className="form-control"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="fromCountry">From Country:</label>
            <input
              type="text"
              value={fromCountry}
              onChange={(e) => setFromCountry(e.target.value)}
              className="form-control"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="toCountry">To Country:</label>
            <input
              type="text"
              value={toCountry}
              onChange={(e) => setToCountry(e.target.value)}
              className="form-control"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="date">Date:</label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="form-control"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="lastUpdate">Last Update:</label>
            <input
              type="date"
              value={lastUpdate}
              onChange={(e) => setLastUpdate(e.target.value)}
              className="form-control"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="status">Status:</label>
            <input
              type="text"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="form-control"
              required
            />
          </div>
          <div className="d-flex justify-content-end">
            <button
              type="button"
              onClick={onClose}
              className="btn btn-secondary mr-2"
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Add Cargo
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CargoModal;
